import { render, staticRenderFns } from "./RateCardForm.vue?vue&type=template&id=90da8908&scoped=true&"
import script from "./RateCardForm.vue?vue&type=script&lang=js&"
export * from "./RateCardForm.vue?vue&type=script&lang=js&"
import style0 from "./RateCardForm.vue?vue&type=style&index=0&id=90da8908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da8908",
  null
  
)

export default component.exports